//@ts-nocheck
import { useAxiosInstance } from "./useAxiosInstance";
import { deleteCookie } from "./deleteCookie";
import { CreateAxiosDefaults } from "axios";
import { useEffect } from "react";

export type ContentType = 'application/json'
    | 'application/EDI-X12'
    | 'application/EDIFACT'
    | 'application/javascript'
    | 'application/octet-stream'
    | 'application/ogg'
    | 'application/pdf'
    | 'application/xhtml+xml'
    | 'application/x-shockwave-flash'
    | 'application/ld+json'
    | 'application/xml'
    | 'application/zip'
    | 'application/x-www-form-urlencoded'
    | 'audio/mpeg'
    | 'audio/x-ms-wma'
    | 'audio/vnd.rn-realaudio'
    | 'audio/x-wav'
    | 'image/gif'
    | 'image/jpeg'
    | 'image/png'
    | 'image/tiff'
    | 'image/vnd.microsoft.icon'
    | 'image/x-icon'
    | 'image/vnd.djvu'
    | 'image/svg+xml'
    | 'multipart/mixed'
    | 'multipart/alternative'
    | 'multipart/related (using by MHTML (HTML mail).)'
    | 'multipart/form-data'
    | 'text/css'
    | 'text/csv'
    | 'text/html'
    | 'text/javascript (obsolete)'
    | 'text/plain'
    | 'text/xml'
    | 'video/mpeg'
    | 'video/mp4'
    | 'video/quicktime'
    | 'video/x-ms-wmv'
    | 'video/x-msvideo'
    | 'video/x-flv'
    | 'video/webm'
    | 'application/vnd.oasis.opendocument.text'
    | 'application/vnd.oasis.opendocument.spreadsheet'
    | 'application/vnd.oasis.opendocument.presentation'
    | 'application/vnd.oasis.opendocument.graphics'
    | 'application/vnd.ms-excel'
    | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    | 'application/vnd.ms-powerpoint'
    | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    | 'application/msword'
    | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    | 'application/vnd.mozilla.xul+xml'
    | '%future added value'
export interface UseHttpRequestProp {
    omitToken?: boolean,
    provisionalToken?: string
    contentType?: ContentType
    options?: CreateAxiosDefaults

}
const useHttpRequest = <T>(params: UseHttpRequestProp) => {
    const _options = { ...(params?.options ?? {}) };
    const { axiosInstance, abortCountroller } = useAxiosInstance(params?.omitToken!, params?.provisionalToken!, _options)
    
    const getRequest = async (url: string) => {
        try {

            const response = await axiosInstance.get(url)

             if (response.status === 200)
                return response.data

        } catch (error) {
            console.log("http error", error)
            
            throw new Error(error?.response?.data?.message! as string ?? error?.message)
        }
    }
    const postRequest = async (url: string, body: T) => {
        try {

            const response = await axiosInstance.post(url, body, { headers: { "Content-Type": params?.contentType! } })

             if (response.status === 200)
                return response.data

        } catch (error) {
            console.log("http error", error)
            
            if (error?.response?.status! && error?.response?.status! === 400) {
                if (error?.response?.data?.errors) {
                    const errors = Object.values(error?.response?.data?.errors) as Array<string>
                    const throwErrors = errors?.map(e => e)?.join(', ')
                    throw new Error(throwErrors)
                }
            }
            
            throw new Error(error?.response?.data?.message! as string ?? error?.message)
        }
    }

    const putRequest = async (url: string, body: T) => {
        try {

            const response = await axiosInstance.put(url, body, { headers: { "Content-Type": params?.contentType! } })

            if (response.status === 200)
                return response.data

        } catch (error) {
            console.log("http error", error)
            
            if (error?.response?.status! && error?.response?.status! === 400) {
                if (error?.response?.data?.errors) {
                    const errors = Object.values(error?.response?.data?.errors) as Array<string>
                    const throwErrors = errors?.map(e => e)?.join(', ')
                    throw new Error(throwErrors)
                }
            }
            
            throw new Error(error?.response?.data?.message! as string ?? error?.message)
        }
    }
    const deleteRequest = async (url: string, body?: T) => {
        try {

            const response = await axiosInstance.delete(url, { headers: { "Content-Type": params?.contentType! } })

             if (response.status === 200)
                return response.data

        } catch (error) {
            console.log("http error", error)
           
            throw new Error(error?.response?.data?.message! as string ?? error?.message)
        }
    }

    const patchRequest = async (url: string, body: T) => {
        try {

            const response = await axiosInstance.patch(url, body, { headers: { "Content-Type": params?.contentType! } })

             if (response.status === 200)
                return response.data

        } catch (error) {
            console.log("http error", error)
           
            if (error?.response?.status! && error?.response?.status! === 400) {
                if (error?.response?.data?.errors) {
                    const errors = Object.values(error?.response?.data?.errors) as Array<string>
                    const throwErrors = errors?.map(e => e)?.join(', ')
                    throw new Error(throwErrors)
                }
            }
            
            throw new Error(error?.response?.data?.message! as string ?? error?.message)
        }
    }
   
    return { getRequest, postRequest, putRequest, deleteRequest, patchRequest, abortCountroller }
}
export default useHttpRequest
